<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-3 col-lg-3 col-md-2 "></div>
            <div class="col-9 col-lg-9 col-md-10 ">
                <div class="header-block">
                    <h2>Переваги Anima</h2>
                    <p>
                        <a href="https://www.deloitte.com/content/dam/assets-zone2/uk/en/docs/industries/energy-resources-industrials/2023/deloitte-uk-mental-health-report-2022.pdf">За даними Deloitte</a>, корпоративний скринінг ментального здоров’я генерує 530% ROI. Точні та науково обґрунтовані дані про ментальне здоров’я дозволяють сформувати культуру турботи, підвищити залученість та знизити плинність кадрів.
                    </p>
                </div>
            </div>
        </div>

        <app-about-us-b-item [item]="item" *ngFor="let item of items"></app-about-us-b-item>

        <!--        <app-achivement></app-achivement>-->

    </div>
</section>
